import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import http from "@/utils/http";
import api from "@/utils/api";
import "./index.scss";
import PDFModal from "./component/PDFModal"
import { useLocation } from 'react-router-dom';
import commonFn from "@/utils/commonFn";
import ButtonList from "./component/ButtonList";
import { CustomTable, CustomTableExtend } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const [selectedList, setSelectedList] = useState([]);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [payByList, setPayByList] = useState([]);
  const [greater, setGreater] = useState([]);
  const [small, setSmall] = useState([]);

  const initTableHead = {
    vendorName: null,
    propUnit: null,
    requestDate: null,
    numberOfUnits: null,
    requestNumber: null,
    status: null,
    payAmount: null,
    jobType:null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const initColumns = [
    // {
    //   dataIndex: '#'
    // },
    {
      title: 'Vendor',
      dataIndex: "vendorName",
      titleType: 'Input',
      width: 200,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'vendorName')
    },
    {
      title: 'Prop-Unit',
      dataIndex: "propUnit",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'propUnit')
    },
    {
      title: 'Create Date & Time',
      dataIndex: "requestDate",
      titleType: 'DatePicker',
      isSorter: false,
      format: 'MM/DD/YYYY HH:mm',
      onChange: (e) => tableFilterFn(e, 'requestDate', 'DatePicker'),
    },
    {
      title: 'Request No#',
      dataIndex: "requestNumber",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'requestNumber')
    },
    {
      title: 'Request Status',
      dataIndex: "requestStatus",
      titleType: 'Select',
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: [
        { label: "Open", value: 1 },
        { label: "Close", value: 2 },
      ],
      render: (text) => {
        const requestStatusMatch = {
          1: "Open",
          2: "Close",
        }
        return requestStatusMatch[text] || ""
      },
      onChange: e => tableFilterFn(e, 'status', 'Select'),
    },
    {
      title: 'Clock In Time',
      dataIndex: "clockInTime",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
    },
    {
      title: 'Pay Amount',
      dataIndex: "payAmount",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      render: (text, record) => {
        if (text == null || text === "") return "-";
        return (
          <span
            onClick={() => handleAmountClick(record)}
            className="CA-AS-AmountStyle"
          >
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(text)}
          </span>
        );
      },
      onChange: e => tableFilterFn(e, 'payAmount'),
    },
    {
      title: 'Pay Period',
      dataIndex: "payPeriod",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
    },
    {
      title: 'Job Type',
      dataIndex: "jobType",
      titleType: 'Input',
      isSorter: true,
      width: 180,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'jobType'),
    },
    {
      title: 'Material $',
      dataIndex: "materialAmount",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
    },
    {
      title: "Rejected Reason",
      dataIndex: "rejectedReason",
      titleType: "Input",
      width: 150,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'rejectedReason'),
    },
    {
      title: 'Supervisor',
      dataIndex: "supervisor",
      titleType: '',
      width: 180,
      isSorter: true,
      sortterMultiple: 3,
    },
  ]
  
  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  const setGreaterAndSmallFn = async(list = []) => {
    if(!list.length) return
    const ids = list.map(item => item.foreignId).join(",");
    const result = await http.get(api.ApprovalRecent, { params: { ids } });
    setGreater(result?.greater || []); 
    setSmall(result?.small || []); 
  }

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      email: new URLSearchParams(location.search).get("email"),
      transactionsType: new URLSearchParams(location.search).get("type"),
      batchGroup: new URLSearchParams(location.search).get("batchGroup"),
    };
    const response = await http.get(api.getShowApprovalOfMaintenance, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    // setSelectedList([])
    setGreaterAndSmallFn(list)
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  //复选框
  const rowSelection = {
    selectedRowKeys: selectedList.map(item => item.vendorPaymentId),
    getCheckboxProps: (record) => ({
      style: record.isEmpty ? { display: "none" } : {}, 
      disabled: record.approve === "Waiting For Approval" 
    }),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedList(selectedRows);
    },
  };

  const PDFModalRef = useRef();
  
  const handleAmountClick = (record) => {
    setCurrentRecord(record);
    PDFModalRef?.current?.setModalOpen(true);
  };

  const getDictionaryFn = async(value) => {
    const params = {
        type:'util_payment',
        value
    }
    const response = await http.get(api.getDictionary, { params });
    switch (value) {
      case 'payBy':
        setPayByList(response)
        break;
      default:
        break;
    }
  }

  const initColunmsFn = () => {
    setSelectedList([]);
    setTableHead(initTableHead);
    setColumns(initColumns);
  }
    
  useEffect(() => {
    getDictionaryFn('payBy')
  }, [])

  useEffect(() => {
    if(payByList.length){
      setColumns(initColumns);
    }
  }, [payByList]);


  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])

  const downLoadFn = async () => {
    const params = {
      ...tableHead,
      email: new URLSearchParams(location.search).get("email"),
      transactionsType: new URLSearchParams(location.search).get("type"),
      batchGroup: new URLSearchParams(location.search).get("batchGroup"),
    }
    const blob = await http.get(api.exportApprovalOfMaintenanceCsv, {params, responseType: 'blob'});
    return {
      blob,
      name: `Maintenance`,
    };
  };

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('ApprovalDownload') && 'download']}
        downLoadFn={() => downLoadFn()}
      >
        <ButtonList
          email={new URLSearchParams(location.search).get("email")}
          transactionsType={new URLSearchParams(location.search).get("type")}
          moduleType={new URLSearchParams(location.search).get("module")}
          selectedList={selectedList}
          refreshTableFn={() => setRefreshKey(+new Date())}
        />
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "checkbox",
          ...rowSelection,
        }}
        rowClassName={(record) => {
          if(greater.includes(record.vendorPaymentId)){
            return ["greater-row"]
          }
          if(small.includes(record.vendorPaymentId)){
            return "small-row"
          }
          return [record.vendorPaymentId]
        }}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="300px"
        tableCss="AS-tableClass"
      />

      <PDFModal ref={PDFModalRef} record={currentRecord} />

    </div>
  );
});
export default MainTable;
